/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
import { Multiselect } from 'multiselect-react-dropdown';
import { Formik, Form } from 'formik';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Loader from 'features/Loader/Loader';
import { createExerciseSchema } from 'utils/validators/exercise';
import {
  exerciseTypes,
  exerciseMuscles,
  exerciseMechanicsType,
  exerciseLevels,
  exerciseForces
} from 'utils/constants/selectFieldsOptions'

import TextField from 'shared/components/text-field/TextField';
import SelectDropdown from 'shared/components/select-dropdown/SelectDropdown';
import Button from 'shared/components/button/Button';
import { createExercise, resetExerciseModel } from '../../../ducks/workoutActions';

class ExerciesCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      otherMuscles: []
    };

    this.style = {
      chips: {
        background: "#121211",
      },
      searchBox: {
        "borderRadius": "6px",
        "background": "transparent",
        "border": "1px solid #b8b8b8",
        "boxShadow": "none",
        "display": "block",
        "fontFamily": "'Montserrat', sans-serif",
        "fontSize": "14px",
        "fontWeight": "400",
        "lineHeight": "1.57",
        "padding": "9px 12px",
        "width": "100%",
        "WebkitAppearance": "none",
        "MozAppearance": "none",
        "appearance": "none",
        "color": "#b8b8b8",
        "maxHeight": "300px",
        "overflow": "auto",
        "position": "relative",
        "backgroundImage": "url('../../../../../src/assets/img/icons/down.png')",
        "backgroundPosition": "center right",
        "backgroundRepeat": "no-repeat",
        "textTransform": "capitalize"
      }
    }

    this.types = this.prepareOptions(exerciseTypes);
    this.muscles = this.prepareOptions(exerciseMuscles);
    this.mechanicsType = this.prepareOptions(exerciseMechanicsType);
    this.levels = this.prepareOptions(exerciseLevels);
    this.forces = this.prepareOptions(exerciseForces)
  }

  componentDidMount() {
    this.props.resetExerciseModel();
  }

  prepareOptions = options => {
    return options.map(option => {
      return {value: option, option: option}
    });
  }

  updateOtherMuscles = selectedList => {
    this.setState({otherMuscles: [...selectedList]});
  }

  render() {
    const {
      setModalOpen,
      openModal,
      createExercise,
      exerciseUniquenessError,
      doneCreatingExercise
    } = this.props;

    if (doneCreatingExercise) {
      let { handleSelectResult, newCreatedExercise, resetExerciseModel } = this.props;
      handleSelectResult({...newCreatedExercise});
      setModalOpen(false);
      resetExerciseModel();
    }

    return (
      <div>
        <Modal isOpen={openModal} className="exercies-create-modal">
          <ModalHeader>
            <span>Create Exercise</span>
            <a className="modal-close" onClick={() => setModalOpen(false)}>
              Close
            </a>
          </ModalHeader>
          <ModalBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
              }}
              onSubmit={values => {
                return createExercise({
                  ...values,
                  other_muscles_worked: this.state.otherMuscles
                }, setModalOpen);
              }}
              validationSchema={createExerciseSchema}
            >
              {formik => (
                <Form>
                  {formik.isSubmitting ? (
                    <Loader />
                  ) : (
                  <div>
                    <div className="form-row">
                      <div className="col">
                        <TextField
                          type="text"
                          name="name"
                          label="Exercise Name"
                          placeholder="Exercise Name"
                          error={exerciseUniquenessError || (formik.submitCount > 0 && formik.errors.name)}
                        />
                      </div>
                      <div className="col">
                        <SelectDropdown
                          name="type"
                          options={this.types}
                          label="Type"
                          error={formik.submitCount > 0 && formik.errors.type}
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="col">
                        <SelectDropdown
                          name='main_muscle_worked'
                          options={this.muscles}
                          label="Main Muscle Worked"
                        />
                      </div>
                      <div className="col">
                        <div className="form-group form-group-select ">
                          <label className='form-label' htmlFor={this.otherMusclesRef}>
                            Other Muscles
                          </label>
                          <Multiselect
                            options={exerciseMuscles}
                            placeholder="Other Muscles"
                            isObject={false}
                            closeIcon='circle'
                            style={this.style}
                            selectedValues={this.state.otherMuscles}
                            onSelect={this.updateOtherMuscles}
                            onRemove={this.updateOtherMuscles}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="col">
                        <SelectDropdown
                          name="mechanics_type"
                          options={this.mechanicsType}
                          label="Mechanics Type"
                        />
                      </div>
                      <div className="col">
                        <SelectDropdown name="level" options={this.levels} label="Level" />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="col">
                        <SelectDropdown name="force" options={this.forces} label="Force" />
                      </div>
                      <div className="col"></div>
                    </div>

                    <div className="form-action">
                      <Button
                        id=""
                        type="submit"
                        btnBlock=""
                        btnSize=""
                        color="primary"
                        label="Create"
                        disabled={formik.isSubmitting}
                      />
                    </div>
                  </div>
                )}
                </Form>
              )}
            </Formik>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    exerciseUniquenessError: state.workoutReducer.exerciseUniquenessError,
    doneCreatingExercise: state.workoutReducer.doneCreatingExercise,
    newCreatedExercise: state.workoutReducer.newCreatedExercise
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetExerciseModel: () => dispatch(resetExerciseModel()),
    createExercise: exercise => dispatch(createExercise(exercise))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExerciesCreate);


